import { Outlet, Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faBook, faUsers, faChalkboardTeacher, faCalculator, faKey, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import logo from "../../assets/LogoSolo.png";
import { RoleGate } from '../middleware/RoleGate.jsx';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap'

const MainLayout = () => {

    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);
    const handleLogout = () => {
        localStorage.removeItem("token");
        navigate("/login");
        window.location.reload();
    }
    const handleNavClick = () => {
        setExpanded(false); 
    };

    return (
        <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
            <>
                <Navbar expand="lg" className="navbar" expanded={expanded} onToggle={(isOpen)=>setExpanded(isOpen)}>
                    <div className="container-fluid">
                        <Link to='/' className='logo' onClick={handleNavClick}>
                            <img src={logo} alt="Kolping Chile Maestro de Socios" className='App-logo' />
                        </Link>

                        {/* Botón hamburguesa */}
                        <Navbar.Toggle aria-controls="navbar-nav" />

                        {/* Contenedor de enlaces */}
                        <Navbar.Collapse id="navbar-nav">
                            <Nav className="ms-auto flex-column flex-lg-row">
                                {/* Los links se muestran en fila en pantallas grandes, en columna en móviles */}
                                <Nav.Link as={Link} to="/inicio" onClick={handleNavClick}> <FontAwesomeIcon className='d-lg-none' icon={faHome} /> Inicio</Nav.Link>
                                <Nav.Link as={Link} to="/bitacora" onClick={handleNavClick}> <FontAwesomeIcon className='d-lg-none' icon={faBook} /> Bitácora</Nav.Link>
                                <Nav.Link as={Link} to="/mostrar" onClick={handleNavClick}> <FontAwesomeIcon className='d-lg-none' icon={faUsers} /> Socios</Nav.Link>
                                <Nav.Link as={Link} to="/cursos" onClick={handleNavClick}> <FontAwesomeIcon className='d-lg-none' icon={faChalkboardTeacher} /> Cursos</Nav.Link>
                                <Nav.Link as={Link} to="/contabilidad" onClick={handleNavClick}> <FontAwesomeIcon className='d-lg-none' icon={faCalculator} /> Contabilidad</Nav.Link>


                                {/* Dropdown solo para escritorio */}
                                <NavDropdown title="Configuración" id="dropdown" className="d-none d-lg-block">
                                    <NavDropdown.Item as={Link} to="/cambiar-contraseña"><FontAwesomeIcon icon={faKey} /> Cambiar contraseña</NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <RoleGate allowedRoles={['Administrador']}>
                                        <NavDropdown.Item as={Link} to="/panel-adm"><FontAwesomeIcon icon={faUsers} /> Panel Admin</NavDropdown.Item>
                                        <NavDropdown.Divider />
                                    </RoleGate>

                                    <NavDropdown.Item onClick={handleLogout}>
                                        <FontAwesomeIcon icon={faRightFromBracket} /> Cerrar sesión
                                    </NavDropdown.Item>
                                </NavDropdown>

                                {/* En móviles se muestran directo */}
                                <div className="d-lg-none">
                                    <Nav.Link as={Link} to="/cambiar-contraseña" onClick={handleNavClick}>
                                        <FontAwesomeIcon icon={faKey} /> Cambiar contraseña
                                    </Nav.Link>
                                    <RoleGate allowedRoles={['Administrador']}>
                                        <Nav.Link as={Link} to="/panel-adm" onClick={handleNavClick}>
                                            <FontAwesomeIcon icon={faUsers} /> Panel Admin
                                        </Nav.Link>
                                    </RoleGate>
                                    <Nav.Link onClick={() => { handleNavClick(); handleLogout(); }} >
                                        <FontAwesomeIcon icon={faRightFromBracket} /> Cerrar sesión
                                    </Nav.Link>
                                </div>
                            </Nav>
                        </Navbar.Collapse>
                    </div>
                </Navbar>
            </>
            <main className="flex-grow-1 p-4">
                <Outlet /> {/* Aquí se cargan las páginas internas */}
            </main>
        </div>
    );
};

export default MainLayout;
